import { useRouter } from "next/router";
import {
  MouseEvent,
  MutableRefObject,
  useContext,
  useEffect,
  useRef,
  useState
} from "react";
import { ProductsRowProps } from "../../../models/home-rows";
import { API } from "../../../services/api-services";
import AppContext from "../../../services/app-context-services";
import { lastNumberPart, _ } from "../../../services/text-services";
import FetchData from "../fetch-data/fetch-data";
import SingleProduct from "../single-product/single-product";
import styles from "./products-row.module.scss";

function ProductsRow({
  products,
  title,
  sectionTitle,
  activeIndex,
  series,
  isRelatedFile,
  rowNumber,
  size,
  blur,
  itemsPerSlideInput,
  gaTitle
}: ProductsRowProps) {
  const appCtx = useContext(AppContext);
  const { isLoggedIn } = appCtx;
  const router = useRouter();
  const [isHovering, setIsHovered] = useState<boolean>(false);
  const productsContainer = useRef<HTMLDivElement>();
  let firstItem = useRef<HTMLDivElement>();
  const [hasNext, setHasNext] = useState<boolean>();
  const [hasPrev, setHasPrev] = useState<boolean>(false);
  const [itemsPerSlide, setItemsPerSlide] = useState<number>(0);
  const [slideBy, setSlideBy] = useState<number>(1);
  const [slide, setSlide] = useState<number>(0);
  const [lastItem, setLastItem] = useState<number>(0);
  const [sizeOfSlide, setSizeOfSlide] = useState<number>(0);
  const [firstItemMarginRight, setFirstItemMarginRight] = useState<number>(0);
  const [itemClassName, setItemClassName] = useState<string>();
  const [relatedResponseData, setRelatedResponseData] = useState({
    count: 0,
    position: 0,
    id: 0
  });
  useEffect(() => {
    // You now have access to `window`
    // setFirstItem(productsContainer.current.firstChild).;
    firstItem.current = productsContainer.current?.firstChild as HTMLDivElement;
    const itemsNum = itemsPerSlideInput
      ? itemsPerSlideInput
      : detectItemsPerSlide();
    if (!itemsPerSlideInput) {
      const a = detectItemsPerSlide();

      setItemsPerSlide(a);
    } else setSlideBy(1);
    // setItemsPerSlide(10);

    setHasNext(itemsNum < products?.length);
    setSlide(itemsNum);
    setLastItem(itemsNum);
    // setItemClassName(setClassItem)
    // setSizeOfSlide(sizeOfSlide);
  }, [products]);

  if (products.length === 0) return <></>;
  const onMouseEnter = (itemIndex: number, event: MouseEvent) => {
    // if (itemIndex !== activeIndex) activeIndex = null
    hoverOnLasts(true, itemIndex, event);
    // setHasPrev(!hasPrev);
  };

  const hoverOnLasts = (enter: boolean, itemIndex: number, event: any) => {
    // console.log({firstItemMarginRight}, {sizeOfSlide});
    if (event.target?.classList.value.indexOf("last") !== -1) {
      itemsPerSlide && setSizeOfSlide(100 / Math.floor(itemsPerSlide));

      if (firstItem?.current)
        firstItem.current.style.marginRight = `calc(${
          enter === true
            ? size !== "full"
              ? firstItemMarginRight - sizeOfSlide * 1.4
              : firstItemMarginRight - sizeOfSlide * 0.7
            : firstItemMarginRight
        }%)`;
    }
  };

  const onMouseLeave = (i: number, event: MouseEvent) => {
    // console.log("hi mouse enter", { i }, event);
  };

  const detectItemsPerSlide = () => {
    const { clientWidth } = document.body;
    // console.log({ clientWidth });

    let numItems = 0;
    if (!isRelatedFile) {
      if (clientWidth < 576) numItems = 2.5;
      else if (clientWidth < 768) numItems = 3.5;
      else if (clientWidth < 992) numItems = 4.5;
      else if (clientWidth < 1600) numItems = 5.5;
      else numItems = 7.5;
      // else if (clientWidth < 992) numItems = 4.5;
      // else if (clientWidth < 1400) numItems = 6.5;
      // else numItems = 7.5;
    } else {
      if (clientWidth < 576) numItems = 2;
      else if (clientWidth < 768) numItems = 3;
      else if (clientWidth < 992) numItems = 4;
      else if (clientWidth < 1600) numItems = 6;
      else numItems = 7.5;
      // else if (clientWidth < 992) numItems = 4;
      // else if (clientWidth < 1400) numItems = 6;
      // else numItems = 7.5;
    }
    setSlideBy(1);
    return numItems;
  };

  const defineLastItem = (prevOrNext: number) => {
    let listOfSingleProduct = document.querySelectorAll(".single_product");
    listOfSingleProduct.forEach(item => {
      if (item.classList.value.includes("last")) {
        item.classList.remove("last");
      }
    });
    setLastItem(lastItem + prevOrNext);
    setLastClass(lastItem);
  };

  const setMargin = (marginRihgt: number) => {
    if (firstItem?.current)
      firstItem.current.style.marginRight = `calc(${marginRihgt}%)`;
  };

  const setLastClass = (i: number) => {
    let isItLastItem;
    const isFullSlide = size === "half" ? false : true;
    if (!isFullSlide) {
      if (i === Math.floor(lastItem)) {
        isItLastItem = true;
      }
    } else {
      if (i === lastItem - 1) {
        isItLastItem = true;
      }
    }
    return isItLastItem;
  };

  const nextSlide = () => {
    defineLastItem(1);
    let hasNext = slide < products?.length;
    let hasPrev = slide + 1 > itemsPerSlide;
    setHasPrev(hasPrev);
    setHasNext(hasNext);

    if (hasNext && firstItem) {
      setFirstItemMarginRight(firstItemMarginRight - 100 / itemsPerSlide);
      setSlide(slideBy + slide);
      setMargin(firstItemMarginRight - 100 / itemsPerSlide);
    }
  };

  const prevSlide = () => {
    defineLastItem(-1);
    let hasNext = slide < products?.length;
    let hasPrev = slide > itemsPerSlide;
    setHasPrev(hasPrev);
    setHasNext(hasNext);

    if (hasPrev && firstItem) {
      setFirstItemMarginRight(firstItemMarginRight + 100 / itemsPerSlide);
      setSlide(slide - slideBy);
      setMargin(firstItemMarginRight + 100 / itemsPerSlide);
    }
  };

  const setClassItem = (itemsPerSlide: number | null | undefined) => {
    if (!itemsPerSlide) return "";
    switch (itemsPerSlide) {
      case 2:
        return "two_item";
      case 3:
        return "three_item";
      case 4:
        return "four_item";
      case 5:
        return "five_item";
      case 6:
        return "six_item";
      case 7:
        return "seven_item";
      case 2.5:
        return "two_and_half_item";
      case 3.5:
        return "three_and_half_item";
      case 4.5:
        return "four_and_half_item";
      case 5.5:
        return "five_and_half_item";
      case 6.5:
        return "six_and_half_item";
      case 7.5:
        return "seven_and_half_item";
      default:
        return "";
    }
  };

  return (
    <>
      {relatedResponseData.count > 0 && (
        <FetchData
          url={API.request_related_response}
          method="POST"
          body={JSON.stringify({
            position: relatedResponseData.position,
            product_id: lastNumberPart(router?.query?.slug?.[1]),
            product_target_id: relatedResponseData.id
          })}
          onFinally={() => {}}
          counter={relatedResponseData.count}
          unAuthorized={!isLoggedIn}
        />
      )}
      <div>
        {sectionTitle && (
          <h3 className={`${styles.section_title}`}>{_(sectionTitle)}</h3>
        )}
        {title && <h2 className={`${styles.title}`}>{_(title)} ‌</h2>}
        <div className={`${styles.products_container} `}>
          <div
            className={`row flex-nowrap ${styles.products_row} ${
              activeIndex ? "px-0" : ""
            }`}
            ref={productsContainer as MutableRefObject<HTMLDivElement>}
          >
            {products.map((product, i) => (
              <div
                key={`single-product-${product.id}-${i}`}
                className={`
              ${styles.single_product}
              ${styles.product_item} 
              ${setLastClass(i) ? styles.last : ""}
              ${!hasPrev ? styles.disable : ""} 
              ${styles[setClassItem(itemsPerSlide)]}
              `}
                onMouseEnter={event => onMouseEnter(i, event)}
                onMouseLeave={event => onMouseLeave(i, event)}
              >
                <SingleProduct
                  title={title}
                  gaTitle={gaTitle}
                  product={product}
                  series={series}
                  isRelatedFile={!!isRelatedFile}
                  rowNumber={rowNumber}
                  relatedResponse={id => {
                    if (isRelatedFile)
                      setRelatedResponseData(prev => ({
                        count: prev.count + 1,
                        id,
                        position: i
                      }));
                  }}
                />
              </div>
            ))}
          </div>
          {hasNext && (
            <div
              className={`${styles.next_item} ${styles.arrow_item} ${
                !hasNext ? styles.disable : ""
              }`}
              onClick={() => {
                nextSlide();
              }}
            >
              <div className={`${styles.arrow}`}>‹</div>
            </div>
          )}
          {hasPrev && (
            <div
              className={`${styles.prev_item} ${styles.arrow_item}`}
              onClick={() => {
                prevSlide();
              }}
            >
              <div className={`${styles.arrow}`}>›</div>
            </div>
          )}
          <div className={`${blur ? styles.blur_effect : ""}`}></div>
        </div>
      </div>
    </>
  );
}

export default ProductsRow;
